// extracted by mini-css-extract-plugin
export default {"cabecalho":"Cabecalho_cabecalho__HMrxR"};